import { useState, useEffect } from 'react'

/**
 * Custom hook for persisting column order to localStorage
 *
 * @param storageKey - Unique key for localStorage (e.g., 'tasks-column-order')
 * @param defaultOrder - Default column order (array of column IDs)
 * @returns [columnOrder, setColumnOrder]
 */
export function useColumnOrder(
  storageKey: string,
  defaultOrder: string[] = []
): [string[], React.Dispatch<React.SetStateAction<string[]>>] {
  const [columnOrder, setColumnOrder] = useState<string[]>(() => {
    try {
      const stored = localStorage.getItem(storageKey)
      if (stored) {
        return JSON.parse(stored)
      }
    } catch (error) {
      console.error('Error loading column order from localStorage:', error)
    }
    return defaultOrder
  })

  useEffect(() => {
    try {
      if (columnOrder.length > 0) {
        localStorage.setItem(storageKey, JSON.stringify(columnOrder))
      }
    } catch (error) {
      console.error('Error saving column order to localStorage:', error)
    }
  }, [columnOrder, storageKey])

  return [columnOrder, setColumnOrder]
}
